import { LabsModeSwitch } from "@/zapi-frontend/features/LabsModeSwitch";
import { CustomSnippetsUrlSection } from "./CustomSnippetsUrlSection";
import { UserSettings } from "./_UserSettings";
import { ChangePasswordSection } from "./ChangePasswordSection";

export function ProfileSection() {
  return (
    <div className="space-y-8">
      <UserSettings />
      <ChangePasswordSection />
      <LabsModeSwitch showDescription={true} />
      <CustomSnippetsUrlSection />
    </div>
  );
}
